"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataError {
    constructor(errorCode, path, message) {
        this.errorCode = errorCode;
        this.path = path;
        if (!message) {
            if (errorCode.endsWith("NS")) {
                this.message = `${path} not set`;
            }
            else if (errorCode.endsWith("NV")) {
                this.message = `${path} invalid`;
            }
            else if (errorCode.endsWith("NA")) {
                this.message = `${path} not available`;
            }
            else {
                this.message = `${path} bad data`;
            }
        }
        else {
            this.message = message;
        }
    }
}
exports.default = DataError;
//# sourceMappingURL=dataError.class.js.map